/**
 * Love Lust — JavaScript propio.
 *
 * BUSCADOR EN PANEL (estilo Rhode): al tocar "Buscar" en el header se abre un panel
 * por el costado, sin cambiar de página. Al abrirlo muestra las sugerencias y, debajo,
 * los productos destacados con foto. Mientras escribes, los reemplaza por los productos
 * que calzan (búsqueda predictiva de Shopify).
 * Medidas copiadas de rhodeskin.com en 1440px: panel ~47% del ancho, título 22px,
 * caja de búsqueda 22px / 59px de alto, sugerencias 18px.
 */
(function () {
  var SUGERENCIAS = [
    { texto: 'bralette lupe', url: '/search?q=lupe&type=product' },
    { texto: 'bralette bruna', url: '/search?q=bruna&type=product' },
    { texto: 'lolas', url: '/collections/lolas' },
    { texto: 'lolas lift', url: '/products/lolas-lift' },
    { texto: 'boob tape', url: '/search?q=boob+tape&type=product' },
    { texto: 'calzones', url: '/collections/calzones' },
    { texto: 'trajes de baño', url: '/collections/todo-trajes-de-bano' },
    { texto: 'lencería', url: '/collections/todo-lenceria' },
    { texto: 'contacto', url: '/pages/contacto' }
  ];

  var DESTACADOS = [
    'bralette-lupe-rosado',
    'bralette-bruna-negro',
    'lolas-lift',
    'colaless-paz-tiro-alto-nude'
  ];

  var CSS =
    '.llsd-ov{position:fixed;inset:0;z-index:60;background:rgba(26,26,26,.45);opacity:0;visibility:hidden;transition:opacity .28s ease,visibility .28s ease}' +
    '.llsd-ov.is-open{opacity:1;visibility:visible}' +
    '.llsd{position:fixed;top:0;right:0;bottom:0;z-index:61;width:min(47vw,760px);min-width:560px;background:#F1F0ED;color:#3A3733;' +
    'font-family:var(--ll-sans,"Outfit",sans-serif);display:flex;flex-direction:column;' +
    'transform:translateX(100%);transition:transform .32s cubic-bezier(.62,.04,.26,1);-webkit-font-smoothing:antialiased}' +
    '.llsd.is-open{transform:translateX(0)}' +
    '.llsd__head{position:relative;flex:none;padding:26px 34px 0}' +
    '.llsd__title{margin:0;text-align:center;font-size:22px;font-weight:700;text-transform:lowercase;letter-spacing:-.01em}' +
    '.llsd__close{position:absolute;top:20px;right:26px;width:38px;height:38px;border:0;background:none;color:inherit;cursor:pointer;padding:0}' +
    '.llsd__close svg{width:24px;height:24px;display:block;margin:0 auto}' +
    '.llsd__form{flex:none;padding:22px 34px 0}' +
    '.llsd__input{box-sizing:border-box;width:100%;height:62px;padding:0 22px;border:0;border-radius:12px;background:#fff;' +
    'font-family:inherit;font-size:21px;color:#3A3733;-webkit-appearance:none;appearance:none}' +
    '.llsd__input::placeholder{color:#A8A49C}' +
    '.llsd__input:focus{outline:2px solid #DDD8CF}' +
    '.llsd__body{flex:1;overflow-y:auto;padding:26px 34px 44px;-webkit-overflow-scrolling:touch}' +
    '.llsd__label{margin:0 0 12px;font-size:19px;font-weight:700;text-transform:lowercase}' +
    '.llsd__sugs{list-style:none;margin:0;padding:0}' +
    '.llsd__sugs a{display:block;padding:7px 0;font-size:18px;line-height:1.5;color:#6F6A63;text-decoration:none;text-transform:lowercase}' +
    '.llsd__sugs a:hover{color:#1A1A1A}' +
    '.llsd__sep{height:1px;background:#DDD8CF;margin:26px 0 8px}' +
    '.llsd__res{list-style:none;margin:0;padding:0}' +
    '.llsd__res li{border-bottom:1px solid rgba(221,216,207,.7)}' +
    '.llsd__item{display:flex;align-items:center;gap:20px;padding:14px 0;text-decoration:none;color:inherit}' +
    '.llsd__thumb{flex:none;width:74px;height:96px;border-radius:10px;background:#fff;overflow:hidden}' +
    '.llsd__thumb img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.llsd__name{font-size:15px;font-weight:700;text-transform:uppercase;letter-spacing:.02em;line-height:1.35}' +
    '.llsd__price{display:block;margin-top:5px;font-size:14px;font-weight:400;color:#6F6A63;text-transform:none}' +
    '.llsd__all{display:inline-flex;align-items:center;justify-content:center;margin-top:26px;min-height:50px;padding:0 30px;' +
    'border-radius:40px;background:#67645E;color:#fff;font-size:15px;letter-spacing:.02em;text-transform:uppercase;text-decoration:none}' +
    '.llsd__empty{padding:12px 0;font-size:16px;color:#6F6A63}' +
    '@media(max-width:900px){.llsd{width:100%;min-width:0}.llsd__head{padding:18px 20px 0}.llsd__form{padding:16px 20px 0}' +
    '.llsd__body{padding:20px 20px 36px}.llsd__input{height:56px;font-size:17px}.llsd__label{font-size:17px}' +
    '.llsd__sugs a{font-size:17px}.llsd__thumb{width:64px;height:84px}.llsd__name{font-size:14px}}';

  var panel, overlay, input, body, timer = null, ultima = '', destacadosHTML = null;

  function money(valor) {
    var n = Math.round(parseFloat(valor));
    if (!isFinite(n)) return '';
    var s = String(Math.abs(n));
    var out = '';
    var c = 0;
    for (var i = s.length - 1; i >= 0; i--) {
      out = s.charAt(i) + out;
      c++;
      if (c % 3 === 0 && i > 0) out = '.' + out;
    }
    return (n < 0 ? '-$' : '$') + out;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function conAncho(u, ancho) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + ancho;
  }

  function fila(url, foto, titulo, precio) {
    return '<li><a class="llsd__item" href="' + esc(url) + '">' +
      '<span class="llsd__thumb">' + (foto ? '<img src="' + esc(foto) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="llsd__name">' + esc(titulo) +
      (precio != null && precio !== '' ? '<span class="llsd__price">' + money(precio) + '</span>' : '') +
      '</span></a></li>';
  }

  function vistaSugerencias() {
    var html = '<p class="llsd__label">sugerencias:</p><ul class="llsd__sugs">';
    for (var i = 0; i < SUGERENCIAS.length; i++) {
      html += '<li><a href="' + esc(SUGERENCIAS[i].url) + '">' + esc(SUGERENCIAS[i].texto) + '</a></li>';
    }
    html += '</ul>';
    if (destacadosHTML) html += '<div class="llsd__sep"></div>' + destacadosHTML;
    return html;
  }

  function cargarDestacados() {
    if (destacadosHTML !== null) return;
    destacadosHTML = '';
    var pendientes = DESTACADOS.length;
    var filas = new Array(DESTACADOS.length);

    DESTACADOS.forEach(function (handle, idx) {
      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p) {
            var foto = conAncho(p.featured_image || (p.images && p.images[0]) || '', 220);
            filas[idx] = fila('/products/' + p.handle, foto, p.title, (p.price || 0) / 100);
          }
        })
        .catch(function () {})
        .then(function () {
          pendientes--;
          if (pendientes === 0) {
            var l = filas.filter(Boolean).join('');
            destacadosHTML = l ? '<ul class="llsd__res">' + l + '</ul>' : '';
            if (panel.classList.contains('is-open') && !input.value.trim()) {
              body.innerHTML = vistaSugerencias();
            }
          }
        });
    });
  }

  function vistaResultados(q, productos) {
    if (!productos.length) {
      return '<p class="llsd__empty">No encontramos nada para “' + esc(q) + '”.</p>' +
        '<div class="llsd__sep"></div>' + vistaSugerencias();
    }
    var html = '<ul class="llsd__res">';
    for (var i = 0; i < productos.length; i++) {
      var p = productos[i];
      var foto = conAncho((p.featured_image && p.featured_image.url) || p.image || '', 220);
      var precio = (p.price_min != null && p.price_min !== '') ? p.price_min : p.price;
      html += fila(p.url, foto, p.title, precio);
    }
    html += '</ul><a class="llsd__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Ver todos los resultados</a>';
    return html;
  }

  function buscar(q) {
    if (!q || q.length < 2) {
      body.innerHTML = vistaSugerencias();
      return;
    }
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (q !== ultima) return;
        var productos = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        body.innerHTML = vistaResultados(q, productos);
      })
      .catch(function () {
        body.innerHTML = '<p class="llsd__empty">No pudimos buscar en este momento.</p>' + vistaSugerencias();
      });
  }

  function abrir(e) {
    if (e) e.preventDefault();
    cargarDestacados();
    overlay.classList.add('is-open');
    panel.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    body.innerHTML = vistaSugerencias();
    input.value = '';
    setTimeout(function () { input.focus(); }, 180);
  }

  function cerrar() {
    overlay.classList.remove('is-open');
    panel.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function construir() {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    overlay = document.createElement('div');
    overlay.className = 'llsd-ov';

    panel = document.createElement('aside');
    panel.className = 'llsd';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Buscar');
    panel.innerHTML =
      '<div class="llsd__head">' +
        '<p class="llsd__title">buscar</p>' +
        '<button type="button" class="llsd__close" aria-label="Cerrar">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>' +
        '</button>' +
      '</div>' +
      '<form class="llsd__form" action="/search" method="get" role="search">' +
        '<input type="hidden" name="type" value="product">' +
        '<input class="llsd__input" type="search" name="q" placeholder="Escribe aquí" autocomplete="off" autocorrect="off" autocapitalize="off">' +
      '</form>' +
      '<div class="llsd__body"></div>';

    document.body.appendChild(overlay);
    document.body.appendChild(panel);

    input = panel.querySelector('.llsd__input');
    body = panel.querySelector('.llsd__body');

    panel.querySelector('.llsd__close').addEventListener('click', cerrar);
    overlay.addEventListener('click', cerrar);
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && panel.classList.contains('is-open')) cerrar();
    });

    input.addEventListener('input', function () {
      var q = input.value.trim();
      ultima = q;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { buscar(q); }, 220);
    });

    panel.querySelector('.llsd__form').addEventListener('submit', function (ev) {
      if (!input.value.trim()) ev.preventDefault();
    });
  }

  function engancharGatillos() {
    var gatillos = document.querySelectorAll('.ll-header__act--search, [data-action="toggle-search"]');
    Array.prototype.forEach.call(gatillos, function (el) {
      el.removeAttribute('data-action');
      el.addEventListener('click', abrir);
    });
  }

  function iniciar() {
    if (document.querySelector('.llsd')) return;
    construir();
    engancharGatillos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();